import { render, staticRenderFns } from "./addressModal.vue?vue&type=template&id=f8dfb53e"
import script from "./addressModal.vue?vue&type=script&lang=js"
export * from "./addressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports